import { Stack } from '@mui/material';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate.tsx';
import { BlockSelectField } from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

export function PatientUploadFormFields() {
  const { value } = useSelectedNodeField<api.PatientUpload.DocumentType>('config.documentType');

  return (
    <Stack gap={2}>
      <BlockSelectField
        fieldName="config.documentType"
        label="Document Type"
        helperText="e.g. FREEHAND_BODY_DIAGRAM"
        options={Object.values(api.PatientUpload.DocumentType).map((documentType) => ({
          label: documentType,
          value: documentType,
        }))}
        clearable
      />
      <BlockValueTemplateField
        label="Previsit Form Template ID"
        fieldName="config.previsitFormTemplateId"
        helperText="Enter the previsitFormTemplateId (e.g. from a GetFormSet block)"
      />
      {value &&
        [
          api.PatientUpload.DocumentType.OcrVerification,
          api.PatientUpload.DocumentType.InsuranceCard,
        ].includes(value) && (
          <BlockValueTemplateField
            label="Insurance Info ID"
            fieldName="config.patientInsuranceInformationId"
            helperText="Enter the patient insurance information ID"
          />
        )}
    </Stack>
  );
}
